import { StudentCourseModel } from '../student-course.model';

export class StudentPastCourseModel extends StudentCourseModel {}

export function StudentPastCourseModel_ClassTransform_Type() {
	return StudentPastCourseModel;
}
